import PropTypes from 'prop-types';
import React from 'react';

import { apiErrorPropType, organiserAbridgedPropType } from '../../proptypes';

import Container from '../Container';
import LoadingEllipsis from '../LoadingEllipsis';
import OrganiserDetailPageMeta from './components/OrganiserDetailPageMeta';
import OrganiserDetail from '../OrganiserDetail';

import { container } from './styles.module.css';

/**
 * Organiser detail page presentational component.
 * Combines organiser detail component with loading and/or error components.
 * */
const OrganiserDetailPage = ({ loading, error, organiser, searchQuery }) => {
  if (organiser) {
    return (
      <div>
        <OrganiserDetailPageMeta {...organiser} query={searchQuery} />
        <OrganiserDetail {...organiser} searchQuery={searchQuery} />
      </div>
    );
  } else if (loading) {
    return (
      <Container className={container}>
        <LoadingEllipsis htmlTag="h1" />
      </Container>
    );
  }

  return (
    <Container className={container}>
      <h1>
        {error && error.status === 404
          ? 'Organiser not found'
          : 'Something went wrong'}
      </h1>
    </Container>
  );
};

OrganiserDetailPage.propTypes = {
  /**
   * Boolean describing current loading state.
   */
  loading: PropTypes.bool,
  /**
   * Object representing current error state.
   */
  error: apiErrorPropType,
  /**
   * Organiser data object.
   */
  organiser: organiserAbridgedPropType,
  /**
   * Query object for 'search' query.
   */
  searchQuery: PropTypes.shape(),
};

OrganiserDetailPage.defaultProps = {
  loading: false,
  error: undefined,
  organiser: undefined,
  searchQuery: undefined,
};

export default OrganiserDetailPage;
